"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _SceneLayouts = require("../../../../../constants/SceneLayouts");
var _Camera = require("./Camera.styled");
var _ActionItemTooltip = _interopRequireDefault(require("../../ActionItemTooltip/ActionItemTooltip"));
var Camera = function Camera(_ref) {
  var onToggleCamera = _ref.onToggleCamera,
    maxCamerasExceeded = _ref.maxCamerasExceeded,
    knockId = _ref.knockId,
    isCameraOn = _ref.isCameraOn;
  var tooltipMessage = maxCamerasExceeded ? "".concat(_SceneLayouts.CAMERA_PRESENTER_LIMIT, "/").concat(_SceneLayouts.CAMERA_PRESENTER_LIMIT, " cameras are already active.") : 'Set the initial state of the camera when the user enters the studio';
  var handleClick = maxCamerasExceeded ? function () {} : onToggleCamera;
  return /*#__PURE__*/_react["default"].createElement(_Camera.CameraWrapper, null, /*#__PURE__*/_react["default"].createElement(_ActionItemTooltip["default"], {
    target: "camera-icon-".concat(knockId),
    message: tooltipMessage,
    placement: "left",
    noPointerEvent: true
  }, /*#__PURE__*/_react["default"].createElement(_Camera.CameraContainer, {
    color: "light",
    variant: "outlined",
    onClick: handleClick,
    "data-testid": "camera-button",
    $isDisabled: maxCamerasExceeded,
    id: "camera-icon-".concat(knockId)
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    color: isCameraOn & !maxCamerasExceeded ? '#33373D' : '#DE2F1B',
    icon: isCameraOn && !maxCamerasExceeded ? _freeSolidSvgIcons.faVideo : _freeSolidSvgIcons.faVideoSlash
  }))));
};
Camera.propTypes = {
  isCameraOn: _propTypes["default"].bool,
  onToggleCamera: _propTypes["default"].func.isRequired,
  maxCamerasExceeded: _propTypes["default"].bool,
  knockId: _propTypes["default"].string
};
var _default = exports["default"] = Camera;